var jose = require('node-jose');
var axios = require("axios");

const region = 'us-east-2';
const userPoolID = 'us-east-2_D8NRxoJAc';
const appClientID = '58vp19kp4tmqcst2n7iounh03h';
const keysURL = 'https://cognito-idp.' + region + '.amazonaws.com/' + userPoolID + '/.well-known/jwks.json';

function VerifyJWT(token, callback) {
    var sections = token.split('.');
    // get the kid from the headers prior to verification
    var header = jose.util.base64url.decode(sections[0]);
    header = JSON.parse(header);
    var kid = header.kid;
    // download the public keys
    axios.get(keysURL).then(response => {
        if (response.status == 200) {
            // var keys = JSON.parse(response.data)['keys'];
            var keys = response.data['keys'];
            // search for the kid in the downloaded public keys
            var keyIndex = -1;
            for (var i = 0; i < keys.length; i++) {
                if (kid == keys[i].kid) {
                    keyIndex = i;
                    break;
                }
            }
            if (keyIndex == -1) {
                callback('Public key not found in jwks.json');
            }
            // construct the public key
            jose.JWK.asKey(keys[keyIndex]).
                then(function (result) {
                    // verify the signature
                    jose.JWS.createVerify(result).
                        verify(token).
                        then(function (result) {
                            // now we can use the claims
                            var claims = JSON.parse(result.payload);
                            // additionally we can verify the token expiration
                            var currentTs = Math.floor(new Date() / 1000);
                            if (currentTs > claims.exp) {
                                callback('Token is expired');
                            }
                            // and the Audience (use claims.client_id if verifying an access token)
                            if (claims.client_id != appClientID) {
                                callback('Token was not issued for this audience');
                            }
                            callback(null, claims);
                        }).
                        catch(function () {
                            callback('Signature verification failed');
                        });
                });
        }
    });
}

export { VerifyJWT, userPoolID, appClientID }
